var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$store.state.meta.title || '壹心理'),expression:"$store.state.meta.title || '壹心理'"}]},[(_vm.routerState)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }